// The bottle: a green glass bottle lying on its side, neck along local −Z,
// centred on its spin axis. Primitive geometry — swap for a GLB later (keep
// the neck on −Z and the centre at the origin). Decoration: not collidable.

import React from 'react';

const GLASS = '#2f9a5c', LABEL = '#f3e7c9', CAP = '#c9a227';
const nc = { collidable: false };

export function BottleProp({ glow = false }: { glow?: boolean }) {
  const emissive = glow ? '#3dffb0' : '#000000';
  return (
    <group userData={nc}>
      {/* Body (lying along Z): cylinder's axis is Y, so tip it over. */}
      <group rotation={[Math.PI / 2, 0, 0]}>
        <mesh position={[0, 0.05, 0]} castShadow userData={nc}>
          <cylinderGeometry args={[0.055, 0.055, 0.2, 20]} />
          <meshStandardMaterial color={GLASS} roughness={0.15} metalness={0.1} transparent opacity={0.88} emissive={emissive} emissiveIntensity={glow ? 0.35 : 0} />
        </mesh>
        <mesh position={[0, 0.05, 0]} userData={nc}>
          <cylinderGeometry args={[0.0565, 0.0565, 0.08, 20, 1, true]} />
          <meshStandardMaterial color={LABEL} roughness={0.8} />
        </mesh>
        {/* Shoulder */}
        <mesh position={[0, -0.075, 0]} castShadow userData={nc}>
          <cylinderGeometry args={[0.022, 0.055, 0.05, 20]} />
          <meshStandardMaterial color={GLASS} roughness={0.15} transparent opacity={0.88} emissive={emissive} emissiveIntensity={glow ? 0.35 : 0} />
        </mesh>
        {/* Neck */}
        <mesh position={[0, -0.14, 0]} castShadow userData={nc}>
          <cylinderGeometry args={[0.018, 0.022, 0.08, 14]} />
          <meshStandardMaterial color={GLASS} roughness={0.15} transparent opacity={0.88} emissive={emissive} emissiveIntensity={glow ? 0.35 : 0} />
        </mesh>
        <mesh position={[0, -0.185, 0]} userData={nc}>
          <cylinderGeometry args={[0.021, 0.021, 0.015, 14]} />
          <meshStandardMaterial color={CAP} roughness={0.4} metalness={0.6} />
        </mesh>
      </group>
    </group>
  );
}

export default BottleProp;
